import partnerPlans from '@/views/config/partner-refer/plans/auto-can-partner';
import { mapGetters } from 'vuex';
import defaultPartnerPlansTemplate from '@/views/config/partner-refer/plans/default-template';

const COMPONENT_KEY_MAP = {
  cart: 'cart',
  config: 'config',
  initConfig: 'initModalContent',
};

export default {
  computed: {
    ...mapGetters(['partnerRefer', 'lastShowInEligibleMsg', 'showInEligibleMsg', 'partnerMessageLoading', 'partnerFeaturesDependOnRules']),
  },
  methods: {
    getCurrentComponent(compKey) {
      // get current partner name and format to lowercase
      const partnerName = this.partnerRefer?.partnerName?.toLowerCase();
      // get current component with component key
      return partnerPlans?.[partnerName]?.components?.[compKey] ?? defaultPartnerPlansTemplate?.components?.[compKey];
    },
    getRenderContent(compKey) {
      // current check result is ineligible and current check status is not pending
      if (this.showInEligibleMsg && !this.partnerMessageLoading) return null;
      // last check result is ineligible and current check status is pending
      if (this.lastShowInEligibleMsg && this.partnerMessageLoading) return null;
      return this.getCurrentComponent(compKey);
    },
    getPlanCartContent() {
      if (!this.partnerFeaturesDependOnRules?.useCustomCartMode) return null;
      return this.getRenderContent(COMPONENT_KEY_MAP.cart);
    },
    getPlanCardContent() {
      if (!this.partnerFeaturesDependOnRules?.usePlanCardMode) return null;
      return this.getRenderContent(COMPONENT_KEY_MAP.config);
    },
    getInitPlanConfigContent() {
      return this.getCurrentComponent(COMPONENT_KEY_MAP.initConfig);
    }
  },
};
